module.exports = __webpack_public_path__ + "media/images/flags/4x3/mdg-335074852cd54f97d8e39e4cb68357e5.svg";